<script lang="ts">
  import { _, t } from "svelte-i18n";
  import { settings } from "../stores/settings.ts";

  console.log("ListHeader.svelte");

  export let query_vars = {
    posts_per_page: 12,
    paged: 1,
    orderby: menu_order,
  };
  export let total_matches = 0;
  export let products = null;
  export let description = "";

  $: from =
    products?.length > 0 && total_matches > 0
      ? query_vars.posts_per_page *
          (query_vars.paged === 0 ? 0 : query_vars.paged - 1) +
        1
      : 0;

  $: to =
    products?.length > 0 && total_matches > 0
      ? Math.min(
          query_vars.posts_per_page *
            (query_vars.paged === 0 ? 1 : query_vars.paged),
          total_matches,
        )
      : 0;

  $: console.log(
    "ListHeader.svelte",
    "products?.length:",
    products?.length,
    "total_matches:",
    total_matches,
    "from:",
    from,
    "to:",
    to,
    "query_vars:",
    query_vars,
  );

  export let changeSortOrder = (ev) => {};
</script>

<header class="woocommerce-products-header">
  {description}
</header>
<div class="woocommerce-notices-wrapper" />
<div class="freshio-sorting">
  <button class="filter-toggle" aria-expanded="false">
    <button>
      <i class="freshio-icon-filter" /><span>{$_("category.Filter")}</span>
    </button>
  </button>
  <!-- <button class="filter-toggle-dropdown" aria-expanded="false">
    <i class="freshio-icon-filter" /><span>{$_("category.Filter")}</span>
  </button> -->
  <div class="woocommerce-result-count2">
    <span
      class="svelte-result-content"
      data-svelte-managed="true"
      data-component="svelte-category-app"
    >
      {$_("category.Showing")}
      {from} – {to} od {total_matches}
      {$_("category.results")}
    </span>
  </div>
  <!-- {console.log($settings.showElements.productList)} -->
  {#if $settings.showElements.productList.gridListToggle}
    <div class="gridlist-toggle desktop-hide-down">
      <a
        href="/trgovina/?layout=grid"
        id="grid"
        class="active"
        title={$_("category.Grid View")}><i class="freshio-icon-th-large" /></a
      >
      <a
        href="/trgovina/?layout=list"
        id="list"
        class=""
        title={$_("category.List View")}><i class="freshio-icon-th-list" /></a
      >
    </div>
  {/if}
  <form class="woocommerce-ordering" method="get">
    <select
      name="orderby"
      class="orderby"
      aria-label="Narudžba"
      bind:value={query_vars.orderby}
      on:change={changeSortOrder}
    >
      <option value="menu_order title">{$_("category.Default sorting")}</option>
      <option value="popularity">{$_("category.Sort by popularity")}</option>
      <option value="rating">{$_("category.Sort by average rating")}</option>
      <option value="date">{$_("category.Sort by latest")}</option>
      <option value="price">{$_("category.Sort by price: low to high")}</option>
      <option value="price-desc"
        >{$_("category.Sort by price: high to low")}</option
      >
    </select>
    <input type="hidden" name="paged" value="1" />
  </form>
</div>

<style>
  .filter-toggle button {
    display: none;
    align-items: center;
  }

  @media screen and (max-width: 1023px) {
    .filter-toggle button {
      display: flex;
    }
  }

  .woocommerce-result-count2 {
    margin-right: auto;
  }
  /* Ensure the wrapper inherits all woocommerce-result-count styling */
  .woocommerce-result-count2 .svelte-result-content {
    display: contents; /* Makes the span behave as if it doesn't exist for layout */
  }
</style>
